import { hasElementSourceMap, toValue } from '@swagger-api/apidom-core';
import JsonPointerError from "./JsonPointerError.mjs";
class EvaluationJsonPointerError extends JsonPointerError {
  constructor(message, structuredOptions) {
    super(message, structuredOptions);
    if (typeof structuredOptions !== 'undefined') {
      this.pointer = structuredOptions.pointer;
      if (Array.isArray(structuredOptions.tokens)) {
        this.tokens = [...structuredOptions.tokens];
      }
      this.failedToken = structuredOptions.failedToken;
      this.failedTokenPosition = structuredOptions.failedTokenPosition;
      this.element = structuredOptions.element.element;
      if (hasElementSourceMap(structuredOptions.element)) {
        this.elementSourceMap = toValue(structuredOptions.element.getMetaProperty('sourceMap'));
      }
    }
  }
}
export default EvaluationJsonPointerError;